export enum DeviceType {
  NotInUse,
  OfficeCheckIn,
  MeetingRoom,
  ProjectRoom,
}

export enum AccessControlMode {
  RestrictedAccess,
  OpenAccess,
}
